// extracted by mini-css-extract-plugin
module.exports = {"root":"Employee_root__2VRxV","item":"Employee_item__3TSOm","photo":"Employee_photo__22PS_"};